export default __webpack_public_path__ + "5f5b73976296ec8a106ad80c279722a4.png";